import React, { useEffect, useState } from "react";
import Card from "components/card";

import {
  Dialog,
  DialogHeader,
  DialogBody,
  Button,
  Spinner,
} from "@material-tailwind/react";

import { ToastContainer, toast } from "react-toastify";

import { HiPencilAlt } from "react-icons/hi";
import { FaTrash } from "react-icons/fa";
import { BsDownload } from "react-icons/bs";
import API_URL from '../../../../config';

import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

import NewStockEnterForm from "./New_stock_enter_form";
import NewStockEnterFormEssay from "./New_stock_enter_form_essay";
import StockEnterEditeForm from "./Stock_enter_edite_form";
import { getAllStockEntryApi, deleteOneStockEnterApi, deleteOneStockEnterHistoryApi, exportStockEnterExcelApi } from "api/stockEntry";
import { updateStockApi } from "api/stock";
import {
  getAllStockEntryEssayApi,
  deleteOneStockEnterEssayApi,
  deleteOneStockEnterEssayHistoryApi,
  exportStockEnterEssayExcelApi,
  updateStockEssayApi,
} from "api/stockEntryEssay";

// Sort helper: order histories by Date (desc) and entries by latest history date
const sortStockEntriesByHistoryDate = (entries = []) => {
  const sortedEntries = entries.map((entry) => {
    const histories = Array.isArray(entry.StockEnterHistory)
      ? [...entry.StockEnterHistory].sort((a, b) => {
          const dA = new Date(a?.Date || 0).getTime();
          const dB = new Date(b?.Date || 0).getTime();
          return dB - dA;
        })
      : [];
    return { ...entry, StockEnterHistory: histories };
  });

  return sortedEntries.sort((a, b) => {
    const latestA = new Date(a?.StockEnterHistory?.[0]?.Date || a?.SelectedDate || 0).getTime();
    const latestB = new Date(b?.StockEnterHistory?.[0]?.Date || b?.SelectedDate || 0).getTime();
    return latestB - latestA;
  });
};

const isExpiringSoon = (dateString, daysThreshold = 30) => {
  if (!dateString) return false;
  const target = new Date(dateString);
  if (isNaN(target.getTime())) return false;
  const now = new Date();
  const diffDays = (target - now) / ((1000 * 60 * 60 * 24) * 6);
  return diffDays >= 0 && diffDays <= daysThreshold;
};

const isDateInPeriod = (dateStr, selectedFromDate, selectedToDate) => {
  if (!dateStr || !selectedFromDate || !selectedToDate) return true;
  const d = new Date(dateStr);
  const from = new Date(selectedFromDate);
  const to = new Date(selectedToDate);
  if (isNaN(d.getTime()) || isNaN(from.getTime()) || isNaN(to.getTime())) return true;
  // inclusive range
  return d.getTime() >= from.getTime() && d.getTime() <= to.getTime();
};
const buildSortedStockEnterRows = (entries = []) => {
  const rows = entries.flatMap((el) => {
    const histories = el.StockEnterHistory && el.StockEnterHistory.length > 0 ? el.StockEnterHistory : [null];
    return histories.map((history, idx) => ({
      key: `${el._id}-${idx}`,
      entry: el,
      history,
      date: history?.Date || el.SelectedDate || null,
    }));
  });

  return rows.sort((a, b) => {
    const dateA = new Date(a.date).getTime() || 0;
    const dateB = new Date(b.date).getTime() || 0;
    return dateB - dateA;
  });
};
function StockEnterTable({ accessList, isAdmin }) {
  // stock_essai => essai stock only, stock_enter => regular stock only,
  // both => both, none => regular stock driven by the Add right.
  const flagEssai = !!accessList.StockEssai;
  const flagRegular = !!accessList.StockEnter;
  const hasFlags = flagRegular || flagEssai;
  const canRegular = isAdmin || flagRegular || (!hasFlags && !!accessList.Add);
  const canEssai = isAdmin || flagEssai;
  const [showStockEnterModale, setShowStockEnterModale] = useState(false);
  const [showStockEnterEssayModale, setShowStockEnterEssayModale] =
    useState(false);
  const [showStockEnterEditeModale, setShowStockEnterEditeModale] =
    useState(false);
  const [tableData, setTableData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const [inputFilterValue, setInputFilterValue] = useState({
    LotNumber: "",
    Produit: "",
    selectedFromDate: `${new Date().getFullYear()}-01-01`,
    selectedToDate: `${new Date().getFullYear()}-12-31`,
    StockType: !canRegular && canEssai ? "Essai" : "Regular",
  });

  useEffect(() => {
    getInitialData(
      inputFilterValue.Produit,
      inputFilterValue.LotNumber,
      inputFilterValue.selectedFromDate,
      inputFilterValue.selectedToDate,
      inputFilterValue.StockType
    );
  }, []);

  const getInitialData = async (
    Produit,
    LotNumber,
    selectedFromDate,
    selectedToDate,
    StockType
  ) => {
    try {
      setIsLoading(true);

      const fetchStockEntries =
        StockType === "Essai" ? getAllStockEntryEssayApi : getAllStockEntryApi;

      const response = await fetchStockEntries(
        Produit,
        LotNumber,
        selectedFromDate,
        selectedToDate
      );
      const sorted = sortStockEntriesByHistoryDate(response);

      // Keep only history lines whose Date is inside the selected period.
      // If an entry has no histories, fall back to its SelectedDate.
      const filteredByPeriod = sorted
        .map((entry) => {
          const histories = Array.isArray(entry.StockEnterHistory)
            ? entry.StockEnterHistory.filter((h) =>
                isDateInPeriod(
                  h?.Date || entry?.SelectedDate || null,
                  selectedFromDate,
                  selectedToDate
                )
              )
            : [];

          // If there are matching histories, keep only those.
          if (histories.length > 0) {
            return { ...entry, StockEnterHistory: histories };
          }

          // Otherwise, keep the entry only if its SelectedDate is in the period.
          if (isDateInPeriod(entry?.SelectedDate || null, selectedFromDate, selectedToDate)) {
            return { ...entry, StockEnterHistory: [] };
          }

          // No matching dates at all -> drop later via filter.
          return null;
        })
        .filter(Boolean);

      setTableData(filteredByPeriod);
    } catch (err) {
      console.log(err);
    } finally {
      setIsLoading(false);
    }
  };

  const handleFiltersInputChange = (e) => {
    const { name, value } = e.target;
    setInputFilterValue({ ...inputFilterValue, [name]: value });
    getInitialData(
      name == "Produit" ? value : inputFilterValue.Produit,
      name == "LotNumber" ? value : inputFilterValue.LotNumber,
      name == "selectedFromDate" ? value : inputFilterValue.selectedFromDate,
      name == "selectedToDate" ? value : inputFilterValue.selectedToDate,
      name == "StockType" ? value : inputFilterValue.StockType
    );
  };

  const handleDownloadExcel = async () => {
    if (!accessList?.pdf_excel) return;
    try {
      const exportStockEntries =
        inputFilterValue.StockType === "Essai"
          ? exportStockEnterEssayExcelApi
          : exportStockEnterExcelApi;

      const path = await exportStockEntries(
        inputFilterValue.Produit,
        inputFilterValue.LotNumber,
        inputFilterValue.selectedFromDate,
        inputFilterValue.selectedToDate
      );
      if (path) {
        window.open(`${API_URL}/${path}`, "_blank");
      }
    } catch (err) {
      console.log(err);
      toast.error("Erreur lors du téléchargement du fichier", {
        position: "top-right",
        autoClose: 5000,
        theme: "colored",
      });
    }
  };

  const handleStockEnterModale = () => {
    try {
      setShowStockEnterModale(!showStockEnterModale);
    } catch (err) {
      console.log(err);
    }
  };

  const handleStockEnterEssayModale = () => {
    try {
      setShowStockEnterEssayModale(!showStockEnterEssayModale);
    } catch (err) {
      console.log(err);
    }
  };

  const handleStockEnterEditeModale = () => {
    try {
      setShowStockEnterEditeModale(!showStockEnterEditeModale);
    } catch (err) {
      console.log(err);
    }
  };

  const handleDeleteStock = (data, history) => {
    try {
      const isEssai = inputFilterValue.StockType === "Essai";
      const updateStockEntries = isEssai ? updateStockEssayApi : updateStockApi;
      const deleteStockEnter = isEssai ? deleteOneStockEnterEssayApi : deleteOneStockEnterApi;
      const deleteStockEnterHistory = isEssai ? deleteOneStockEnterEssayHistoryApi : deleteOneStockEnterHistoryApi;

      const updatedDepots = []
      const histories = data.StockEnterHistory || []
      const isSingleHistory = histories.length <= 1 || !history

      // For full delete, gather all depots with available stock to reverse
      data.ProductDetails.map(el => {
        el.Stock.map(el2 => {
          if(el2.Disponible !== 0) {
            updatedDepots.push(el2)
          }
        })
      })

      withReactContent(Swal)
        .fire({
          icon: "warning",
          title: "Supprimer ?",
          confirmButtonText: "Supprimer",
        })
        .then(async (result) => {
          if (result.isConfirmed) {
            try {
              if (isSingleHistory) {
                // Reverse all stock and delete the whole entry
                const selectedProductsList = [];
                updatedDepots.map(depot => {
                  selectedProductsList.push({
                    Name: data.Produit,
                    FromD: depot.City,
                    ToD: null,
                    Quantity: parseFloat(depot.Disponible),
                    Type: "StockEnter",
                    TypeOfEnter: "Exit",
                    FromEntry: data._id,
                    LotNumber: data.LotNumber
                  });
                })

                await updateStockEntries(selectedProductsList, "save");
                await deleteStockEnter(data._id);
              } else {
                // Reverse only the selected history quantity and remove that history row
                const qty = parseFloat(history?.Quantity) || 0;
                const depot = history?.Depot;

                const selectedProductsList = [{
                  Name: data.Produit,
                  FromD: depot,
                  ToD: null,
                  Quantity: qty,
                  Type: "StockEnter",
                  TypeOfEnter: "Exit",
                  FromEntry: data._id,
                  LotNumber: data.LotNumber
                }];

                await updateStockEntries(selectedProductsList, "save");
                await deleteStockEnterHistory(data._id, history._id);
              }

              getInitialData(
                inputFilterValue.Produit,
                inputFilterValue.LotNumber,
                inputFilterValue.selectedFromDate,
                inputFilterValue.selectedToDate,
                inputFilterValue.StockType
              );
              Swal.fire("Supprimée", "", "success");
            } catch (err) {
              Swal.fire(err.response.data.error, "", "error");
            }
          }
        });
    } catch (err) {
      Swal.fire(err, "", "error");
    }
  };

  const hadleShowToast = (type, message) => {
    if (type === "success") {
      setShowStockEnterModale(!showStockEnterModale);

      toast.success(message, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });

      getInitialData(
        inputFilterValue.Produit,
        inputFilterValue.LotNumber,
        inputFilterValue.selectedFromDate,
        inputFilterValue.selectedToDate,
        inputFilterValue.StockType
      );
    }
    if (type === "error") {
      toast.error(message, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }
  };

  const hadleShowToastEssay = (type, message) => {
    if (type === "success") {
      setShowStockEnterEssayModale(!showStockEnterEssayModale);

      toast.success(message, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });

      if (inputFilterValue.StockType === "Essai") {
        getInitialData(
          inputFilterValue.Produit,
          inputFilterValue.LotNumber,
          inputFilterValue.selectedFromDate,
          inputFilterValue.selectedToDate,
          inputFilterValue.StockType
        );
      }
    }
    if (type === "error") {
      toast.error(message, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }
  };

  return (
    <Card extra={"w-full pb-10 p-4 h-full"}>
      <ToastContainer />
      <Dialog
        size="xl"
        open={showStockEnterModale}
        handler={handleStockEnterModale}
      >
        <DialogHeader>
          <p className="w-full text-center">Nouvelle entrée de stock</p>
        </DialogHeader>
        <DialogBody>
          <NewStockEnterForm
            closePopup={handleStockEnterModale}
            showToast={hadleShowToast}
          />
        </DialogBody>
      </Dialog>

      <Dialog
        size="xl"
        open={showStockEnterEssayModale}
        handler={handleStockEnterEssayModale}
      >
        <DialogHeader>
          <p className="w-full text-center">Nouvelle entrée de stock (Essai)</p>
        </DialogHeader>
        <DialogBody>
          <NewStockEnterFormEssay
            closePopup={handleStockEnterEssayModale}
            showToast={hadleShowToastEssay}
          />
        </DialogBody>
      </Dialog>

      <Dialog
        size="xl"
        open={showStockEnterEditeModale}
        handler={handleStockEnterEditeModale}
      >
        <DialogHeader>
          <p className="w-full text-center">Modifier entrée de stock</p>
        </DialogHeader>
        <DialogBody>
          <StockEnterEditeForm closePopup={handleStockEnterEditeModale} />
        </DialogBody>
      </Dialog>

      <header className="relative flex flex-col items-center justify-between md:flex-row">
        <div className="mb-5 text-xl font-bold text-navy-700 dark:text-white md:mb-0"></div>
        {canRegular && (
          <Button
            onClick={() => handleStockEnterModale("")}
            className="linear mb-5 rounded-[10px] bg-green-500 px-4 py-2 text-xs font-bold text-white transition duration-200 hover:bg-green-400 active:bg-brand-700 dark:bg-brand-400 dark:hover:bg-brand-300 dark:active:opacity-90 md:mb-0"
          >
            Ajouter une entrée de stock
          </Button>
        )}
        {canEssai && (
          <Button
            onClick={() => handleStockEnterEssayModale("")}
            className="linear mb-5 rounded-[10px] bg-amber-500 px-4 py-2 text-xs font-bold text-white transition duration-200 hover:bg-amber-400 active:bg-brand-700 dark:bg-brand-400 dark:hover:bg-brand-300 dark:active:opacity-90 md:mb-0"
          >
            Ajouter une entrée de stock (Essai)
          </Button>
        )}
        {accessList.pdf_excel && (
          <Button
            onClick={handleDownloadExcel}
            className="linear mb-5 rounded-[10px] bg-gray-500 px-4 py-2 text-xs font-bold text-white transition duration-200 hover:bg-gray-400 active:bg-brand-700 dark:bg-brand-400 dark:hover:bg-brand-300 dark:active:opacity-90 md:mb-0 flex items-center gap-2"
          >
            <BsDownload size={16} />
            Télécharger Excel
          </Button>
        )}
      </header>
      <div className={`mt-5 grid grid-cols-1 gap-5 ${isAdmin || hasFlags ? "md:grid-cols-4" : "md:grid-cols-3"}`}>
        {(isAdmin || hasFlags) && (
          <div>
            <small className="text-sm font-medium text-gray-600 dark:text-white">
              Type de stock :
            </small>
            <div>
              <select
                className={`flex w-full items-center justify-center rounded-xl border bg-white/0 p-2 text-sm outline-none`}
                name="StockType"
                value={inputFilterValue.StockType}
                onChange={handleFiltersInputChange}
              >
                {canRegular && <option value="Regular">Régulier</option>}
                {canEssai && <option value="Essai">Essai</option>}
              </select>
            </div>
          </div>
        )}
        <div>
          <small className="text-sm font-medium text-gray-600 dark:text-white">
            Numéro de lot :
          </small>
          <div>
            <input
              type="text"
              id=""
              placeholder=""
              className={`flex w-full items-center justify-center rounded-xl border bg-white/0 p-2 text-sm outline-none`}
              name="LotNumber"
              value={inputFilterValue.LotNumber}
              onChange={handleFiltersInputChange}
            />
          </div>
        </div>
        <div>
          <small className="text-sm font-medium text-gray-600 dark:text-white">
            Produits :
          </small>
          <div>
            <input
              type="text"
              id=""
              placeholder=""
              className={`flex w-full items-center justify-center rounded-xl border bg-white/0 p-2 text-sm outline-none`}
              name="Produit"
              value={inputFilterValue.Produit}
              onChange={handleFiltersInputChange}
            />
          </div>
        </div>
        <div>
          <small className="text-sm font-medium text-gray-600 dark:text-white">
            Période :
          </small>
          <div>
            <input
              type="date"
              id=""
              placeholder=""
              className={`flex w-full items-center justify-center rounded-xl border bg-white/0 p-2 text-sm outline-none`}
              name="selectedFromDate"
              value={inputFilterValue.selectedFromDate}
              onChange={handleFiltersInputChange}
            />
            <input
              type="date"
              id=""
              placeholder=""
              className={`mt-2 flex w-full items-center justify-center rounded-xl border bg-white/0 p-2 text-sm outline-none`}
              name="selectedToDate"
              value={inputFilterValue.selectedToDate}
              onChange={handleFiltersInputChange}
            />
          </div>
        </div>
      </div>

      <div className="mt-8 overflow-x-scroll">
        <div
          className="mt-8 overflow-x-scroll"
          style={{ height: "50vh", overflowY: "scroll" }}
        >
          <table className="w-full">
            <thead>
              <tr>
                <th className="border-b border-gray-200 pr-28 pb-[10px] text-start dark:!border-navy-700">
                  <p className="text-xs tracking-wide text-gray-600">Date</p>
                </th>
                <th className="border-b border-gray-200 pr-28 pb-[10px] text-start dark:!border-navy-700">
                  <p className="text-xs tracking-wide text-gray-600">
                    Catégorie
                  </p>
                </th>
                <th className="border-b border-gray-200 pr-28 pb-[10px] text-start dark:!border-navy-700">
                  <p className="text-xs tracking-wide text-gray-600">Produit</p>
                </th>
                <th className="border-b border-gray-200 pr-28 pb-[10px] text-start dark:!border-navy-700">
                  <p className="text-xs tracking-wide text-gray-600">
                    Emballage
                  </p>
                </th>
                <th className="border-b border-gray-200 pr-28 pb-[10px] text-start dark:!border-navy-700">
                  <p className="text-xs tracking-wide text-gray-600">
                    Quantité
                  </p>
                </th>
                <th className="border-b border-gray-200 pr-28 pb-[10px] text-start dark:!border-navy-700">
                  <p className="text-xs tracking-wide text-gray-600">Dépôt</p>
                </th>
                <th className="border-b border-gray-200 pr-28 pb-[10px] text-start dark:!border-navy-700">
                  <p className="text-xs tracking-wide text-gray-600">
                    Numero de lot
                  </p>
                </th>
                <th className="border-b border-gray-200 pr-28 pb-[10px] text-start dark:!border-navy-700">
                  <p className="text-xs tracking-wide text-gray-600">
                    Date d'éxpiration
                  </p>
                </th>
                <th className="border-b border-gray-200 pr-28 pb-[10px] text-start dark:!border-navy-700">
                  <p className="text-xs tracking-wide text-gray-600">Actions</p>
                </th>
              </tr>
            </thead>

            {isLoading ? (
              <tbody>
                <tr>
                  <div className="flex w-full items-center justify-center">
                    <Spinner className="h-12 w-12" />
                  </div>
                </tr>
              </tbody>
            ) : (
              <tbody>
                {buildSortedStockEnterRows(tableData).map(({ key, entry: el, history }) => {
                  return (
                    <tr key={key}>
                      <td className="pt-[14px] pb-[18px] sm:text-[14px]">
                        <p className="text-sm font-bold text-navy-700 dark:text-white">
                          {((history?.Date ? new Date(history.Date).toISOString().split("T")[0] : el.SelectedDate) || "")
                            ?.split("T")[0]
                            ?.split("-")
                            ?.reverse()
                            ?.join("/")}
                        </p>
                      </td>
                      <td className="pt-[14px] pb-[18px] sm:text-[14px]">
                        <p className="text-sm font-bold text-navy-700 dark:text-white">
                          {el.Category}
                        </p>
                      </td>
                      <td className="pt-[14px] pb-[18px] sm:text-[14px]">
                        <p className="text-sm font-bold text-navy-700 dark:text-white">
                          {el.Produit}
                        </p>
                      </td>
                      <td className="pt-[14px] pb-[18px] sm:text-[14px]">
                        <p className="text-sm font-bold text-navy-700 dark:text-white">
                          {el.ProductDetails[0]
                            ? el.ProductDetails[0].Packaging +
                              " " +
                              el.ProductDetails[0].Unity
                            : ""}
                        </p>
                      </td>
                      <td className="pt-[14px] pb-[18px] sm:text-[14px]">
                        <p className="text-sm font-bold text-navy-700 dark:text-white">
                          {parseFloat(history?.Quantity || el.Quantity)
                            ? parseFloat(history?.Quantity || el.Quantity).toFixed(2)
                            : ""}
                        </p>
                      </td>
                      <td className="pt-[14px] pb-[18px] sm:text-[14px]">
                        <p className="text-sm font-bold text-navy-700 dark:text-white">
                          {history?.Depot || el.Depot}
                        </p>
                      </td>
                      <td className="pt-[14px] pb-[18px] sm:text-[14px]">
                        <p className="text-sm font-bold text-navy-700 dark:text-white">
                          {el.LotNumber}
                        </p>
                      </td>
                      <td className="pt-[14px] pb-[18px] sm:text-[14px]">
                        {(() => {
                          const expDate = history?.ExperationDate || el.ExperationDate;
                          const isExpired =
                            expDate && !isNaN(new Date(expDate)) && new Date(expDate) < new Date();
                          const soon = isExpiringSoon(expDate, 30);
                          return (
                            <div className="flex flex-col gap-1">
                              <p className="text-sm font-bold text-navy-700 dark:text-white">
                                {expDate
                                  ? expDate.split("T")[0]?.split("-")?.reverse()?.join("/")
                                  : ""}
                              </p>
                              {(isExpired || soon) && (
                                <span
                                  className={`inline-flex w-fit rounded-full px-2 py-1 text-xs font-semibold ${
                                    isExpired
                                      ? "bg-red-100 text-red-700"
                                      : "bg-yellow-100 text-yellow-700"
                                  }`}
                                >
                                  {isExpired ? "Expiré" : "Bientôt expiré"}
                                </span>
                              )}
                            </div>
                          );
                        })()}
                      </td>
                      <td className="pt-[14px] pb-[18px] sm:text-[14px]">
                        <p className="text-sm font-bold text-navy-700 dark:text-white">
                          <div className="flex">
                            {accessList.Delete && (
                              <FaTrash
                                size={20}
                                color="#cf503f"
                                className="cursor-pointer"
                                onClick={() => handleDeleteStock(el, history)}
                              />
                            )}
                          </div>
                        </p>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            )}
          </table>
        </div>
      </div>
    </Card>
  );
}

export default StockEnterTable;
